import React from 'react';
import { createRoot } from 'react-dom/client'

import App from "./App.jsx"
import {I18nextProvider} from 'react-i18next';
import i18next from 'i18next';
import common_en from "./locales/en/common.json";
import common_no from "./locales/no/common.json";
import momentTimeZone from 'moment-timezone'

import './App.scss';

momentTimeZone.tz.setDefault("utc")

i18next.init({
    debug: false,
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    lng: 'no',
    ns: ['common'],
    resources: {
        en: {
            common: common_en
        },
        no: {
            common: common_no
        }
    }
});

const container = document.getElementById('app');
const root = createRoot(container);

root.render(
<I18nextProvider i18n={i18next}>
    <App/>
</I18nextProvider>);
